import { format } from 'date-fns';
import { MoreHorizontal, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { ChatSessionSummary } from '@/services';

interface SessionActionsDropdownProps {
  currentSessionId: string | null;
  sessionsList: ChatSessionSummary[];
  onNewChat: () => void;
  onSwitchSession: (sessionId: string) => void;
  onOpenDropdown: () => void;
  isStreaming: boolean;
}

export function SessionActionsDropdown({
  currentSessionId,
  sessionsList,
  onNewChat,
  onSwitchSession,
  onOpenDropdown,
  isStreaming,
}: SessionActionsDropdownProps) {
  return (
    <DropdownMenu onOpenChange={(open) => { if (open) onOpenDropdown(); }}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-6 w-6" disabled={isStreaming}>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuItem onClick={onNewChat}>
          <Plus className="mr-2 h-4 w-4" />
          New Chat
        </DropdownMenuItem>

        {sessionsList.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="text-xs text-muted-foreground">
              Chat History
            </DropdownMenuLabel>
            {sessionsList.map((session) => (
              <DropdownMenuItem
                key={session.id}
                onClick={() => onSwitchSession(session.id)}
                className={session.id === currentSessionId ? 'bg-accent' : ''}
              >
                <div className="flex flex-col gap-0.5">
                  <span className="text-xs">
                    {format(new Date(session.modified), 'MMM d, yyyy h:mm a')}
                  </span>
                  {session.updated_by_profile?.full_name && (
                    <span className="text-xs text-muted-foreground">
                      {session.updated_by_profile.full_name}
                    </span>
                  )}
                </div>
              </DropdownMenuItem>
            ))}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
